import './Dropdown.css';
import { useEffect, useState } from 'react';

export function Dropdown(props: { options: string[]; selectedOption: string; setSelectedOption: (option: string) => void }) {
   const { options, selectedOption, setSelectedOption } = props;

   const [open, setOpen] = useState(false);

   const handleClick = (e: any) => {
      if (!e.target.closest('.dropdown')) {
         setOpen(false);
      }
   };
   useEffect(() => {
      document.addEventListener('click', handleClick);
      return () => {
         document.removeEventListener('click', handleClick);
      };
   }, []);
   return (
      <div className="flex justifty-start">
         <div
            className={`dropdown ${open ? 'open' : ''}`}
            onClick={() => setOpen(!open)}>
            {selectedOption.substring(0, 1).toLocaleUpperCase() + selectedOption.substring(1)}
            <div className="dropdown-arrow flex items-center">
               <img
                  src="/assets/icons/arrow-down.svg"
                  alt=""
               />
            </div>
            <div className="options">
               {options.map((option) => (
                  <div
                     key={option}
                     className={`flex-1 option ${selectedOption === option ? 'selected' : ''}`}
                     onClick={() => setSelectedOption(option)}>
                     {option.substring(0, 1).toLocaleUpperCase() + option.substring(1)}
                  </div>
               ))}
            </div>
         </div>
      </div>
   );
}
